import {JobNodes, makeJobTaskDescriptor} from "#job-nodes/job-nodes"
import DataObjectReference = JobNodes.DataObjectReference

export type UploadProcessingInput = {
    dataObject: DataObjectReference
    options?: {
        generateTiles?: boolean
    }
}

export type UploadProcessingOutput = {
    dataObject: DataObjectReference
}

export const uploadProcessingMetadataTask = makeJobTaskDescriptor<UploadProcessingInput, UploadProcessingOutput>("UploadProcessing.metadata", 1)
